import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { style: {"height":"100vh","padding-top":"110px"} }
const _hoisted_3 = {
  key: 0,
  class: "with_white_bg pad40"
}
const _hoisted_4 = {
  key: 0,
  class: "w100 mb20 mt20"
}
const _hoisted_5 = { class: "fl" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "振り分けフォームが見つかりませんでした。", -1)
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 3 }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div><div class=\"fl ml10\" style=\"width:300px;\">タイトル</div><div class=\"fl\" style=\"width:300px;\">最終更新日時</div><div class=\"fl\" style=\"width:100px;\">オーナー</div><div class=\"fl\" style=\"width:100px;\"></div><div class=\"clear\"></div></div>", 1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  class: /*#__PURE__*/_normalizeClass(`w100`)
}
const _hoisted_18 = {
  key: 0,
  class: "AvailableTimeContent"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_LinkHeaderAssignForm = _resolveComponent("LinkHeaderAssignForm")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_AssignFormCell = _resolveComponent("AssignFormCell")!
  const _component_FormSettings = _resolveComponent("FormSettings")!
  const _component_OptionModal = _resolveComponent("OptionModal")!
  const _component_LeftNavPanel = _resolveComponent("LeftNavPanel")!
  const _component_InputAstagNameModal = _resolveComponent("InputAstagNameModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createVNode(_component_LinkHeaderAssignForm, {
      ref: "header",
      pageTitle: ``,
      buttonTitle: _ctx.isSP ? null : _ctx.headerTitle,
      buttonEnabled: _ctx.headerButtonEnabled,
      showChangeIcon: true,
      showWhatCal: true,
      showBackButton: true,
      clickChangeName: _ctx.clickChangeName,
      from: `aform`,
      onSelectTab: _ctx.selectTab,
      onClickPinkButton: _ctx.saveForm
    }, null, 8, ["buttonTitle", "buttonEnabled", "clickChangeName", "onSelectTab", "onClickPinkButton"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.selectedTabName == `list`)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            (_ctx.showNewButton())
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("section", {
                    class: "pointer centered circle_button pinkBg fs14 rad8 fw600 mr20 fl",
                    style: {"width":"220px","height":"44px","padding":"11px 8px"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickNew && _ctx.clickNew(...args)))
                  }, " 新しい振り分けフォームを作成 "),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_IconHelp, {
                      width: 21,
                      class: "fl mr10 mt10 text-left",
                      tooltipText: `振り分けフォームをはさむことで、担当者・打ち合わせ時間など、より細分化された公開ページを表示することができます。\n
                            表示された公開ページでフォームの回答内容を確認できます。`
                    })
                  ]),
                  _hoisted_6
                ]))
              : _createCommentVNode("", true),
            _hoisted_7,
            (!_ctx.aforms)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_RoomsLoader)
                ]))
              : (_ctx.aforms.length == 0)
                ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                        width: "40",
                        height: "40"
                      }, null, 8, _hoisted_12)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aforms, (aform, aformindex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${aformindex}${(_ctx.aforms || []).length}${aform.updated_at}${aform.created_at}${aform.id}`
                      }, [
                        _createVNode(_component_AssignFormCell, {
                          aform: aform,
                          isLastCell: aformindex == _ctx.aforms.length - 1,
                          canDelete: aform.is_owner,
                          onEditPage: _ctx.editPage,
                          onCopyPage: _ctx.copyPage,
                          onShowCloseRoomModal: _ctx.showCloseRoomModal
                        }, null, 8, ["aform", "isLastCell", "canDelete", "onEditPage", "onCopyPage", "onShowCloseRoomModal"])
                      ]))
                    }), 128))
                  ])),
            _hoisted_15
          ]))
        : (_ctx.selectedTabName == `detail`)
          ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
              _createElementVNode("section", _hoisted_17, [
                (_ctx.rcm.room)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_FormSettings, {
                        viewFrom: `aform`,
                        onEditField: _ctx.editField,
                        onAddNewField: _ctx.addNewField,
                        editEditableContent: _ctx.editEditableContent
                      }, null, 8, ["onEditField", "onAddNewField", "editEditableContent"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
      _hoisted_19
    ]),
    _createVNode(_component_OptionModal, {
      ref: "OptionModal",
      eventName: `振り分けフォーム設定 課金リクエスト`,
      onClickOK: _ctx.clickOK,
      onClickCancel: _ctx.clickCancel,
      onCloseModal: _ctx.closeOptionModal
    }, null, 8, ["onClickOK", "onClickCancel", "onCloseModal"]),
    _createVNode(_component_LeftNavPanel, {
      ref: "leftPanel",
      panelType: _ctx.panelType,
      onClosePanel: _ctx.closePanel,
      onAddField: _ctx.addField,
      editingField: _ctx.editingField
    }, null, 8, ["panelType", "onClosePanel", "onAddField", "editingField"]),
    _createVNode(_component_InputAstagNameModal, {
      onCreateAform: _ctx.createNewAform,
      createType: _ctx.createType,
      willCreateNewAstag: _ctx.willCreateNewForm
    }, null, 8, ["onCreateAform", "createType", "willCreateNewAstag"])
  ]))
}